import React from "react";
import { SlideScroller } from "../components/Scroller";
// import { Button } from "rebass";
// const GalleryViewButton = styled(({ active, ...props }) => (
//   <Button
//     {...props}
//     borderRadius="0"
//     px="2"
//     py="0"
//     fontSize="0"
//     color={active ? "active" : "inactive"}
//     fontWeight="2"
//     fontFamily="proxima"
//     bg={active ? "lines" : "background"}
//   />
// ))`
//   text-transform: uppercase;
//   border: none;
//   height: 2em;
//   letter-spacing: ${({ theme }) => theme.letterSpacings[1]};
//   &:hover {
//     background: ${({ theme }) => theme.colors["lines"]};
//     color: ${({ theme }) => theme.colors["active "]};
//     cursor: pointer;
//   }
// `;
// const ScrollerControls = ({ ...props }) => {
//   return (
//     <Box {...props}>
//       <GalleryViewButton active>grid</GalleryViewButton>
//       <GalleryViewButton>Cover</GalleryViewButton>
//     <Box/>
//   );
// };

export const Work = ({ projects, zIndex, ...props }) => {
  return <SlideScroller projects={projects} {...props} />;
};
Work.defaultProps = {
  projects: []
};
export default Work;
